import { render, staticRenderFns } from "./IrrAccessRequestDataComponent.vue?vue&type=template&id=9192f3ea"
import script from "./IrrAccessRequestDataComponent.vue?vue&type=script&lang=js"
export * from "./IrrAccessRequestDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports